import { useEffect, useState } from 'react'

import axiosPrivate from '../hooks/useAxiosPrivate'
import useAuth from '../hooks/useAuth'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

const ActiveReferrals = () => {
  const { createInfo } = useAuth()

  const axios = axiosPrivate();
  const navigate = useNavigate();
  const [enquiries, setEnquiries] = useState(null)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchEnquiries()
  }, [])

  const fetchEnquiries = async () => {
    setLoading(true)
    try {
      const response = await axios.get('/enquiries/all')

      if (response.status !== 200) {
        console.error('Error fetching resources:', response)
        createInfo('error', 'Error fetching resources')
      }

      setEnquiries(response.data.result || [])
    } catch (error) {
      console.error('Error fetching resources:', error)
    } finally {
      setLoading(false)
    }
  }

  const statusClass = (requestAccepted) => {
    switch (requestAccepted) {
      case true:
        return 'bg-green-200 text-green-800 border-green-400'
      case undefined:
        return 'bg-orange-200 text-orange-800 border-orange-400 '
      case false:
        return 'bg-rose-200 text-rose-800 border-rose-400'
      default:
        return 'bg-gray-200 text-gray-800'
    }
  }

  const statusText = (requestAccepted, enquiry) => {
    switch (requestAccepted) {
      case true:
        return 'Accepted'
      case undefined:
        return 'Awaiting Review'
      case false:
        return rejectionText(enquiry?.task_info?.counselling_info?.rejection_reason);
      default:
        return 'N/A'
    }
  }

  const rejectionText = (rejectionReason) => {
    switch (rejectionReason) {
      case 'staff_no_policy':
        return 'Not Listed on Policy'
      case 'policy_no_counselling':
        return 'Counselling Not Covered'
      case 'counselling_12_weeks':
        return 'Had Recent Counselling'
      case 'admin':
        return 'Cancelled by Admin'
      default:
        return 'N/A'
    }
  }

  return (
    <div className="mt-2 mb-2">
      {loading ? (
        <p>Loading your enquiries...</p>
      ) : (
        <>
          {!enquiries || enquiries.length === 0 ? (
            <p>No Enquiries</p>
          ) : (
            <>
              <h2 className="text-xl font-medium pb-4">Your Enquiries</h2>
              <div className="max-w-3xl">
                {enquiries.map((enquiry, index) => {
                  let title = enquiry.title.replace('Service Request - ', '')
                  const newCounselling = title === 'Counselling' && enquiry?.task_info?.counselling_v2
                  if (newCounselling) {
                    title += ' (Click to view)';
                  }
                  return (
                    <div 
                      key={index} 
                      className={`flex flex-wrap items-center py-2 justify-between ${newCounselling ? 'cursor-pointer' : ''}`}
                      onClick={() => {
                        if (newCounselling) {
                          navigate(`/counselling-enquiry`, {
                            state: {
                              enquiry: enquiry,
                            },
                          })
                        }
                      }}
                    >
                      <div>
                        <div className="mb-1">
                          <h3 className="font-medium">
                            {title}
                          </h3>
                        </div>
                        <p className="text-sm text-gray-600">
                          {moment(enquiry.created_at).format('dddd Do MMMM YYYY, h:mm A')}
                        </p>
                      </div>
                      {newCounselling && (
                        <div className="w-48 flex justify-center">
                          <p>
                            <span
                              className={`${statusClass(enquiry?.task_info?.counselling_info?.accepted)} text-xs font-semibold px-3 py-1 rounded-full`}
                            >
                              {statusText(enquiry?.task_info?.counselling_info?.accepted, enquiry) || ''}
                            </span>
                          </p>
                        </div>
                      )}
                      <hr className="mt-4 border-[#e8e0ed] basis-full" />
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ActiveReferrals
